import { IsNull } from '@/utils/utils';

export default class SearchCondition {
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        }

        if (IsNull(this.Operation)) {
            this.Operation = SearchConditionOperation.Equal;
        }
        //默认 or
        if (IsNull(this.QueryType)) {
            this.QueryType = 1;
        }
        //默认custom
        if (IsNull(this.ValueType)) {
            this.ValueType = ConditionValueType.Custom;
        }
    }

    Name;
    Value;
    // 搜索条件操作符，默认为`Equal`，`Custom`表示自定义
    Operation;
    //'And' | 'Or' default Or
    QueryType;
    // default ConditionValueType.Custom
    ValueType;
}

export class DataScopeCondition extends SearchCondition {
    constructor(data) {
            super();
            if (data) {
                this.ValueDisplayName = data.ValueDisplayName;
                this.ValueDisplayHtml = data.ValueDisplayHtml;
            }
        }
        // 值显示名
    ValueDisplayName;
    // 值显示的html
    ValueDisplayHtml;
}

export const SearchConditionOperation = {
    //[Description("大于")]
    Above: 'Above',
    //[Description("大于等于")]
    NotBelow: 'NotBelow',
    //[Description("等于")]
    Equal: 'Equal',
    //[Description("小于等于")]
    NotAbove: 'NotAbove',
    //[Description("小于")]
    Below: 'Below',
    //[Description("不等于")]
    NotEqual: 'NotEqual',
    In: 'In',
    NotIn: 'NotIn',
    //[Description("包含")]
    Contain: 'Contain',
    //[Description("包含Or")]
    ContainOr: 'ConatainOr',
    //[Description("不包含")]
    NotContain: 'NotContain',
    ContainNotAbove: 'ContainNotAbove',
    ContainBelow: 'ContainBelow',
    ContainAbove: 'ContainAbove',
    ContainNotBelow: 'ContainNotBelow',
    //[Description("开始于")]
    StartWith: 'StartWith',
    // [Description("结束于")]
    EndWith: 'EndWith',
    ContainStartWith: 'ContainStartWith',
    ContainEndWith: 'ContainEndWith',
    Approximate: 'Approximate',
    IsNull: 'IsNull',
    NotNull: 'NotNull',
    //[Description("为空")]
    IsNone: 'IsNone',
    //[Description("不为空")]
    NotNone: 'NotNone',
    //[Description("自定义")]
    Custom: 'Custom',
    //[Description("等于")]
    EqualOr: 'EqualOr',
};

export const ConditionValueType = {
    Custom: 0,
    System: 1,
    FormField: 2,
};

export const SystemTypeValue = {
    CurrUser: 'CurrUser',
    CurrDept: 'CurrDept',
    CurrentUserCode: 'CurrUserCode',

    FormField: 'FormField',
    Condition: 'Condition',
};

export const SystemType = {
    // 后台自定义查询条件
    Default: 'Default',
    // 场景搜索,高级搜索
    AdvancedSearch: 'AdvancedSearch',
    // 关联
    Relating: 'Relating',
    //列点击
    ListDesign: 'ListDesign',
};